import React from 'react';
import Popup from '../Popup';
import { Container, TextBlock } from './styles';

const SimplePopup = ({ popupIsOpen, onClose, headerKey = '', bodyKey = '', buttonKey = 'app_close', body = '' }) => {
  const content = body || i18n.__(bodyKey);
  const contentPanel = (
    <Container>
      <TextBlock
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </Container>
  );

  return (
    <Popup
      popupIsOpen={popupIsOpen}
      heading={i18n.__(headerKey)}
      id="simple-popup"
      contentPanel={contentPanel}
      buttonLabel={i18n.__(buttonKey)}
      onClose={onClose}
      onClick={onClose}
    />
  );
};

export default SimplePopup;
